import { render, staticRenderFns } from "./detailsInvoice.vue?vue&type=template&id=0f093a9b"
import script from "./detailsInvoice.vue?vue&type=script&lang=js"
export * from "./detailsInvoice.vue?vue&type=script&lang=js"
import style0 from "./detailsInvoice.vue?vue&type=style&index=0&id=0f093a9b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports